"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.cssPropWithFallthroughAndPx = exports.cssPropWithFallthrough = exports.fallThrough = exports.createFallThrough = exports.pathValue = exports.firstDefined = exports.ifProp = exports.combineMixins = void 0;

var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/objectSpread"));

var _stencilReactDesc = require("@amzn/stencil-react-desc");

var _stylesUtils = require("./stylesUtils");

// We use for loop for performance but we are really doing this:
//
// const combineMixins = (...args) => args.map(mixin => mixin(props)).join('\n');
// and aggregating propTypes
var combineMixins = function combineMixins() {
  for (var _len = arguments.length, mixins = new Array(_len), _key = 0; _key < _len; _key++) {
    mixins[_key] = arguments[_key];
  }

  var combinedMixins = function combinedMixins(props) {
    var cssAcc = '';
    var mixin;
    var css;

    for (var i = 0; i < mixins.length; i++) {
      mixin = mixins[i];
      css = typeof mixin === 'function' ? mixin(props) : mixin;
      if (css !== '') cssAcc = cssAcc + '\n' + css;
    }

    return cssAcc;
  };

  var combinedMixinsWithDocs = (0, _stencilReactDesc.describe)(combinedMixins).description('');
  var combinedPropTypes = mixins.reduce(function (propTypes, mixin) {
    if (mixin.describedPropTypes) {
      Object.assign(propTypes, mixin.describedPropTypes);
    } else if (mixin.propTypes) {
      Object.assign(propTypes, mixin.propTypes);
    }

    return propTypes;
  }, {});
  combinedMixinsWithDocs.propTypes = (0, _objectSpread2.default)({}, combinedPropTypes);
  return combinedMixinsWithDocs;
};

exports.combineMixins = combineMixins;

var ifProp = function ifProp(value, str) {
  return value === undefined ? '' : str;
};

exports.ifProp = ifProp;

var firstDefined = function firstDefined() {
  for (var i = 0; i < arguments.length; i++) {
    if ((i < 0 || arguments.length <= i ? undefined : arguments[i]) !== undefined) return i < 0 || arguments.length <= i ? undefined : arguments[i];
  }

  return;
};

exports.firstDefined = firstDefined;

var pathValue = function pathValue(theme, path, defaultValue) {
  var pathArr = typeof path === 'string' ? path.split('.') : path;
  var obj = theme;
  var key;
  if (theme === undefined) return defaultValue;

  while (key = pathArr.shift()) {
    obj = obj[key];
    if (obj === undefined) return defaultValue;
  }

  return obj;
};

exports.pathValue = pathValue;

var createFallThrough = function createFallThrough(obj) {
  return function (key) {
    return obj[key] === undefined ? key : obj[key];
  };
};

exports.createFallThrough = createFallThrough;

var fallThrough = function fallThrough(obj, key) {
  return obj[key] === undefined ? key : obj[key];
};

exports.fallThrough = fallThrough;

var cssPropWithFallthrough = function cssPropWithFallthrough(cssProperty, value, selector) {
  if (value === undefined) {
    return '';
  }

  var themeValue = selector(value);
  return "".concat(cssProperty, ": ").concat(themeValue !== null ? themeValue : value, ";");
};

exports.cssPropWithFallthrough = cssPropWithFallthrough;

var cssPropWithFallthroughAndPx = function cssPropWithFallthroughAndPx(cssProperty, value, selector) {
  if (value === undefined) {
    return '';
  }

  var themeValue = (0, _stylesUtils.px)(selector(value));
  return "".concat(cssProperty, ": ").concat(themeValue !== null ? themeValue : (0, _stylesUtils.px)(value), ";");
};

exports.cssPropWithFallthroughAndPx = cssPropWithFallthroughAndPx;